import { useEffect, useState } from "react";
import { parseAccountDeletionSsoCapabilities } from "../constants/accountDeletionSsoProviders";
import { accountDeletionService } from "../services/accountDeletionService";

const NO_PROVIDERS = Object.freeze([]);

export const useAccountDeletionSsoProviders = (enabled = true) => {
    const [providers, setProviders] = useState(NO_PROVIDERS);

    useEffect(() => {
        let active = true;
        setProviders(NO_PROVIDERS);
        if (!enabled) {
            return () => {
                active = false;
            };
        }

        accountDeletionService.getSsoCapabilities()
            .then((response) => {
                const configuredProviders = parseAccountDeletionSsoCapabilities(response);
                if (active) {
                    setProviders(configuredProviders);
                }
            })
            .catch(() => {
                if (active) {
                    setProviders(NO_PROVIDERS);
                }
            });

        return () => {
            active = false;
        };
    }, [enabled]);

    return providers;
};
